import React, { useState } from 'react';
import { authHelpers } from '../global/supabase';
import { BRANDING } from '../config';
import '../global/styles.css';

// Logo loaded dynamically from config
const ClientLogo = require(`../assets/images/${BRANDING.logoFilename}`);

function Login({ onLoginSuccess, onSwitchToSignup, onForgotPassword }) {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error } = await authHelpers.signIn(
        formData.email,
        formData.password
      );

      if (error) {
        if (error.message.includes('Email not confirmed')) {
          setError('Please check your email and confirm your account before signing in.');
        } else if (error.message.includes('Invalid login credentials')) {
          setError('Invalid email or password. Please try again.');
        } else if (error.message.toLowerCase().includes('banned')) {
          setError('This account has been deactivated. Please contact an administrator.');
        } else {
          setError(error.message);
        }
      } else {
        // Success - user logged in
        onLoginSuccess(data);
      }
    } catch (err) {
      setError('An unexpected error occurred');
    }

    setLoading(false);
  };

  return (
    <div className="container-center">
      <div className="card">
        <div className="logo-container" style={{ textAlign: 'center' }}>
          <img src={ClientLogo} alt={BRANDING.companyFullName} className="logo-location" />
        </div>
        <h2 className="title-auth">Welcome Back</h2>
        <p className="subtitle-auth">Sign in to your {BRANDING.appName} account</p>

        {error && (
          <div className="message error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete="current-password"
                className="form-input input-with-icon"
              />
              <button
                type="button"
                className="input-icon"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {showPassword ? (
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </>
                  ) : (
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="links">
          <div className="link-center">
            <a href="#" onClick={(e) => { e.preventDefault(); onForgotPassword(); }} className="link">
              Forgot your password?
            </a>
          </div>

          <div className="link-center">
            <p>Don't have an account?
              <a href="#" onClick={(e) => { e.preventDefault(); onSwitchToSignup(); }} className="link">
                Sign Up
              </a>
            </p>
          </div>
        </div>
      </div>

      <footer className="footer">
        <p className="text-small">{BRANDING.appName} © {BRANDING.copyrightYear} {BRANDING.copyright}</p>
        <p className="text-small" style={{ marginTop: '4px', fontSize: '0.65rem', opacity: 0.2 }}>
          Produced by <a href="https://appcatalyst.org" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>AppCatalyst</a> for NarcoticTrack
        </p>
      </footer>
    </div>
  );
}

export default Login;